import { brandReviewSlice } from './slice';
import { createAction } from '@reduxjs/toolkit';

import { NAME } from './constants';

const sendToBrandReviewPortal = createAction(`${NAME}/sendToBrandReviewPortal`);

export default { ...brandReviewSlice.actions, sendToBrandReviewPortal };
